import React, { useState, useContext, useRef, useEffect } from 'react';

// MUI
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  withStyles,
} from '@material-ui/core/';

// icon
import PrintIcon from '@material-ui/icons/Print';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import Tooltip from '@material-ui/core/Tooltip';

// styles
// import "../../styles/Products.css";
import { productsStyles } from '../../styles/ProductsStyles';
import { generalStyles } from '../../styles/GeneralStyles';

// actions
import {
  clearPrintQueue,
  deleteFromPrintQueue,
  returnSample,
  updatePrintQueue,
  getQrPresetsForUser,
} from '../../../Actions';

// dependents
import { PrintQueueContext } from '../../../Context/PrintQueueContextProvider';
import { AlertContext } from '../../../Context/AlertContextProvider';
import PrintableQRcodes from './PrintableQRcodes';
import { baseUrl } from '../../../Contants';
import { DialogActions, DialogTitle } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { AppContext } from '../../../Context/AppContextProvide';
import axios from '../../../Util/axiosConfig';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PrintProducts = (props) => {
  const { queue, setUpdate, setSwitchState } = useContext(PrintQueueContext);
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);
  const { user } = useContext(AppContext);

  const [open, setOpen] = useState(props.open);
  const [openDisclaimer, setOpenDisclaimer] = useState(false);
  const [sorted, setSorted] = useState('added');
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [presets, setPresets] = useState([]);
  const [selectedPreset, setSelectedPreset] = useState('');
  // Sheet grid ({ rows, cols }) + the first cell to print on, so a partially-used
  // sticker sheet can be reused. startOffset is 0-based, row-major, and never
  // persisted — it resets to a full sheet each time the dialog opens.
  const [grid, setGrid] = useState(null);
  const [startOffset, setStartOffset] = useState(0);
  const CustomColorTypography = withStyles({
    root: {
      color: '#4E564E',
    },
  })(Typography);

  const productsClasses = productsStyles();
  const generalClasses = generalStyles();
  const isAdmin = user.access_type_cd === 'a';

  useEffect(() => {
    const getLocations = async () => {
      const result = await axios.get(`${baseUrl}/api/admin/locations`);

      if (result.status !== 200) {
        setLocations([]);
        setShowLocationDropdown(false);
        return;
      }

      setLocations(result.data.data);
      setShowLocationDropdown(true);
    };

    if (isAdmin) getLocations();
  }, []);

  useEffect(() => {
    getQrPresetsForUser()
      .then((res) => {
        const list = res.data.data.presets || [];
        const lastId = res.data.data.last_preset_id;
        setPresets(list);
        setGrid(res.data.data.grid || null);
        const initial =
          (lastId && list.find((p) => p.preset_id === lastId)) ? lastId
            : (list.find((p) => p.is_default) || list[0] || {}).preset_id;
        if (initial) setSelectedPreset(initial);
      })
      .catch(() => {});
  }, []);

  // Always default to a full sheet when the dialog opens — never inherit a stale
  // start position (that would silently waste a whole sheet).
  useEffect(() => {
    if (open) setStartOffset(0);
  }, [open]);

  // Visual sheet picker: click the first open sticker to resume on a partial sheet.
  // Cells are laid out row-major (left-to-right, top-to-bottom) to match the PDF.
  const renderStartPicker = () => {
    if (!grid || !grid.rows || !grid.cols) return null;
    const total = grid.rows * grid.cols;

    return (
      <Grid container style={{ marginTop: 10 }}>
        <Grid item xs={12}>
          <CustomColorTypography variant="subtitle2" style={{ marginBottom: 6 }}>
            Start position{' '}
            <span style={{ color: '#888', fontWeight: 'normal' }}>
              (click the first open sticker to reuse a partially-printed sheet)
            </span>
          </CustomColorTypography>
          <div
            style={{
              display: 'inline-grid',
              gridTemplateColumns: `repeat(${grid.cols}, 20px)`,
              gap: 3,
              padding: 6,
              border: '1px solid #ddd',
              borderRadius: 4,
              background: '#fafafa',
            }}
          >
            {Array.from({ length: total }, (_, i) => {
              const used = i < startOffset;
              const isStart = i === startOffset;
              return (
                <div
                  key={i}
                  onClick={() => setStartOffset(i)}
                  title={`Sticker ${i + 1}`}
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: 3,
                    cursor: 'pointer',
                    border: isStart ? '2px solid #145214' : '1px solid #b0b0b0',
                    backgroundColor: used ? '#e0e0e0' : isStart ? '#228B22' : '#c8e6c9',
                  }}
                />
              );
            })}
          </div>
          <div style={{ marginTop: 6, display: 'flex', alignItems: 'center' }}>
            <Button size="small" onClick={() => setStartOffset(0)} disabled={startOffset === 0}>
              Reset to full sheet
            </Button>
            <span style={{ marginLeft: 10, color: '#555', fontSize: 13 }}>
              Starting at sticker {startOffset + 1} of {total}
            </span>
          </div>
        </Grid>
      </Grid>
    );
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDisclaimerClose = () => {
    setOpenDisclaimer(false);
  };

  const handleOpenDisclaimer = () => {
    setOpenDisclaimer(true);
  };

  const handleUpdatePrintQueue = (printQueueId) => {
    // var uniqueProductIdList = [...new Set(productIdList)];

    updatePrintQueue(printQueueId)
      .then(() => {
        setUpdate(true);
        setMessageType('success');
        setMessage('Print Queue Updated');
        handleAlertOpen();
      })
      .catch((err) => {
        setMessageType('error');
        setMessage('Error Updating Print Queue');
        handleAlertOpen();
      });
  };

  const handleDelete = (printQueueId) => {
    deleteFromPrintQueue(printQueueId)
      .then(() => {
        setMessage('Product Deleted From Queue');
        setMessageType('success');
        handleAlertOpen();
        setUpdate(true);
      })
      .catch(() => {
        setMessage('Error Deleting Product From Queue');
        setMessageType('error');
        handleAlertOpen();
      });
  };

  const handleClearQueue = () => {
    clearPrintQueue()
      .then(() => {
        setMessage('Print queue cleared!');
        setMessageType('success');
        handleAlertOpen();
        setUpdate(true);
        setOpenDisclaimer(false);
        setOpen(false);
      })
      .catch(() => {
        setMessage('Error clearing print queue');
        setMessageType('error');
        handleAlertOpen();
        setOpenDisclaimer(false);
      });
  };

  const handleToggle = (e, value) => {
    if (!value) return;

    setSwitchState(value === 'alphabetical' ? true : false);
    setSorted(value);
    setUpdate(true);
  };

  const renderConfirmation = () => {
    return (
      <Dialog
        open={openDisclaimer}
        onClose={handleDisclaimerClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          Are you sure you want to clear the print queue?
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={handleDisclaimerClose}
            variant="contained"
            className={productsClasses.productsClearQueueN}
            autoFocus
          >
            No
          </Button>
          <Button
            onClick={handleClearQueue}
            variant="contained"
            className={productsClasses.productsClearQueueY}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderPrintList = (data) => {
    if (!data.length) {
      return (
        <div style={{ textAlign: 'center', padding: '48px 20px', color: '#8a8a8a' }}>
          <PrintIcon style={{ fontSize: 44, opacity: 0.35 }} />
          <Typography variant="body1" style={{ marginTop: 8, fontWeight: 600, color: '#6b6b6b' }}>
            Your print queue is empty
          </Typography>
          <Typography variant="body2" style={{ color: '#a0a0a0' }}>
            Add products from their page to queue up QR labels.
          </Typography>
        </div>
      );
    }

    return data.map((item, i) => {
      const {
        manufacturer_name,
        trade_name,
        private_trade_name,
        product_uuid,
        print_queue_id,
      } = item;
      const name =
        private_trade_name != null && private_trade_name !== ''
          ? private_trade_name
          : trade_name;
      return (
        <div key={`${product_uuid}+${i}`}>
          <ListItem style={{ paddingRight: 8 }}>
            <span
              style={{
                minWidth: 26,
                color: '#b0b0b0',
                fontSize: 13,
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {i + 1}.
            </span>
            <ListItemText
              primary={<span style={{ fontWeight: 600, color: '#2c332c' }}>{name}</span>}
              secondary={manufacturer_name}
            />
            <Tooltip title="Add another copy">
              <IconButton
                size="small"
                aria-label="add another copy"
                onClick={() => handleUpdatePrintQueue([product_uuid])}
                style={{ color: '#228B22' }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Remove from queue">
              <IconButton
                size="small"
                aria-label="remove from queue"
                onClick={() => handleDelete(print_queue_id)}
                style={{ color: '#c0392b' }}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </Tooltip>
          </ListItem>
          {i < data.length - 1 && <Divider />}
        </div>
      );
    });
  };

  // Put this here until headers can be sent for the print file
  const userData = localStorage.getItem('userDetails');
  const RequestorUserID = userData ? JSON.parse(userData).user_id : undefined;

  const sectionLabelStyle = {
    color: '#6b6b6b',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    fontSize: 11,
  };

  const locationOptions = locations.map((l) => {
    return (
      <MenuItem
        key={l.location_name}
        aria-label={l.location_name}
        value={l.location_id}
      >
        <Typography>{l.location_name}</Typography>
      </MenuItem>
    );
  });

  return (
    <div>
      {renderConfirmation()}
      {props.buttonLabel ? (
        <Button
          variant="contained"
          onClick={handleOpen}
          className={productsClasses.productFilterButton}
          startIcon={
            <Badge
              max={999}
              overlap="rectangular"
              color="error"
              badgeContent={queue.length ? queue.length : 0}
            >
              <PrintIcon />
            </Badge>
          }
        >
          {props.buttonLabel}
        </Button>
      ) : (
        <IconButton onClick={handleOpen}>
          <Badge
            style={{ width: '35px', color: '#ff682c' }}
            max={999}
            overlap="rectangular"
            badgeContent={queue.length ? queue.length : 0}
          >
            <PrintIcon style={{ color: '4E564E' }} />
          </Badge>
        </IconButton>
      )}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        className={productsClasses.productsPrintQueue}
      >
        <div
          className={generalClasses.header}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 16px 10px 24px',
            borderRadius: '4px 4px 0 0',
          }}
        >
          <Typography variant="h5" style={{ fontWeight: 600, margin: 0, color: '#28C4FC' }}>
            Print Queue{queue.length ? ` · ${queue.length}` : ''}
          </Typography>
          <IconButton onClick={handleClose} aria-label="close" size="small" style={{ color: '#28C4FC' }}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={productsClasses.productsPrintQueueContent}>
          <div style={{ maxWidth: 760, margin: '0 auto', padding: '0 16px' }}>
            {/* Print settings */}
            <Paper elevation={0} style={{ padding: 16, marginBottom: 16, border: '1px solid #e0e0e0' }}>
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12}>
                  <Typography variant="caption" style={sectionLabelStyle}>
                    Print order
                  </Typography>
                  <div style={{ marginTop: 6 }}>
                    <ToggleButtonGroup
                      value={sorted}
                      exclusive="true"
                      onChange={handleToggle}
                      size="small"
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <ToggleButton
                        className={generalClasses.toggle}
                        value="added"
                        aria-label="order added to queue"
                      >
                        Order Added
                      </ToggleButton>
                      <ToggleButton
                        className={generalClasses.toggle}
                        value="alphabetical"
                        aria-label="alphabetical order"
                      >
                        Alphabetical
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </div>
                </Grid>
                {presets.length > 0 && (
                  <Grid item xs={12} sm={showLocationDropdown ? 6 : 12}>
                    <Typography variant="caption" style={sectionLabelStyle}>
                      QR style
                    </Typography>
                    <FormControl variant="filled" size="small" style={{ width: '100%', marginTop: 6 }}>
                      <InputLabel id="qr-preset-label">QR Style</InputLabel>
                      <Select
                        labelId="qr-preset-label"
                        id="qr-preset-list"
                        value={selectedPreset}
                        onChange={(e) => setSelectedPreset(e.target.value)}
                        label="QR Style"
                      >
                        {presets.map((p) => (
                          <MenuItem key={p.preset_id} value={p.preset_id}>
                            {p.preset_name}
                            {p.is_default ? ' (Default)' : ''}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {showLocationDropdown && (
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" style={sectionLabelStyle}>
                      Location
                    </Typography>
                    <FormControl variant="filled" size="small" style={{ width: '100%', marginTop: 6 }}>
                      <InputLabel id="location-list-label">Location List</InputLabel>
                      <Select
                        labelId="location-list-label"
                        id="location-list"
                        value={selectedLocation}
                        onChange={(e) => setSelectedLocation(e.target.value)}
                        label="Location List"
                      >
                        <MenuItem aria-label="None" value="">
                          <em>Select a location</em>
                        </MenuItem>
                        {locationOptions}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </Grid>
            </Paper>

            {/* Queue list */}
            <Paper elevation={0} style={{ border: '1px solid #e0e0e0', marginBottom: 16, overflow: 'hidden' }}>
              <div style={{ maxHeight: 360, overflow: 'auto', background: '#fff' }}>
                <List disablePadding>{renderPrintList(queue)}</List>
              </div>
            </Paper>

            {/* Start position on the sticker sheet */}
            {!!queue.length && grid && (
              <Paper elevation={0} style={{ padding: '4px 16px 12px', marginBottom: 8, border: '1px solid #e0e0e0' }}>
                {renderStartPicker()}
              </Paper>
            )}
          </div>
        </div>
        <DialogActions style={{ padding: '12px 24px', borderTop: '1px solid #e8e8e8' }}>
          <Button onClick={handleClose} style={{ color: '#555' }}>
            Cancel
          </Button>
          <Button
            onClick={handleOpenDisclaimer}
            disabled={!queue.length}
            variant="outlined"
            style={queue.length ? { color: '#c0392b', borderColor: '#c0392b' } : undefined}
          >
            Clear Queue
          </Button>
          <Button
            href={`${baseUrl}/api/user/queue/print?u=${RequestorUserID}&sort=${sorted === 'alphabetical' ? '' : sorted}&loc=${selectedLocation}&presetId=${selectedPreset}&startOffset=${startOffset}`}
            target="_blank"
            disabled={!queue.length}
            autoFocus
            variant="contained"
            startIcon={<PrintIcon />}
            style={queue.length ? { backgroundColor: '#228B22', color: '#FFFFFF' } : undefined}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PrintProducts;
